function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/. */

/**
 * Redirect users that browse to `/` to `signup` or `settings`
 * depending on whether the user is authenticated.
 *
 * @module views/index
 */
import AuthErrors from '../lib/auth-errors';
import CachedCredentialsMixin from './mixins/cached-credentials-mixin';
import Cocktail from 'cocktail';
import CoppaMixin from './mixins/coppa-mixin';
import ExperimentMixin from './mixins/experiment-mixin';
import ThirdPartyAuth from '../templates/partial/third-party-auth.mustache';
import FlowBeginMixin from './mixins/flow-begin-mixin';
import FormPrefillMixin from './mixins/form-prefill-mixin';
import FormView from './form';
import ServiceMixin from './mixins/service-mixin';
import SignedInNotificationMixin from './mixins/signed-in-notification-mixin';
import ThirdPartyAuthMixin from './mixins/third-party-auth-mixin';
import SyncSuggestionMixin from './mixins/sync-suggestion-mixin';
import Template from 'templates/index.mustache';
import checkEmailDomain from '../lib/email-domain-validator';
import PocketMigrationMixin from './mixins/pocket-migration-mixin';
const EMAIL_SELECTOR = 'input[type=email]';

const t = msg => msg;

let IndexView = /*#__PURE__*/function (_FormView) {
  _inherits(IndexView, _FormView);

  var _super = _createSuper(IndexView);

  function IndexView(options) {
    var _this;

    _classCallCheck(this, IndexView);

    _this = _super.call(this, options);

    _defineProperty(_assertThisInitialized(_this), "template", Template);

    _defineProperty(_assertThisInitialized(_this), "partialTemplates", {
      unsafeThirdPartyAuthHTML: ThirdPartyAuth
    });

    _this.config = options.config || {};
    return _this;
  }

  _createClass(IndexView, [{
    key: "viewName",
    get: function get() {
      return 'enter-email';
    }
  }, {
    key: "getAccount",
    value: function getAccount() {
      return this.model.get('account');
    }
  }, {
    key: "beforeRender",
    value: function beforeRender() {
      const account = this.getAccount();
      const relierEmail = this.relier.get('email');

      if (account) {
        this.formPrefill.set(account.pick('email'));
      } else if (relierEmail) {
        this.formPrefill.set('email', relierEmail);
      }
    }
  }, {
    key: "afterRender",
    value: function afterRender() {
      // 1. COPPA checks whether the user is too young in beforeRender.
      // So that COPPA takes precedence, do all other checks afterwards.
      // 2. bounced signup emails get email-first automatically
      // 3. action=email is specified by the firstrun page to specify
      // the email-first flow
      if (this._hasEmailBounced()) {
        // show the index page with an error screen
        return this.chooseEmailActionPage();
      }

      const isLegacySigninSignupDisabled = this.broker.getCapability('disableLegacySigninSignup');
      const action = this.relier.get('action');

      if (isLegacySigninSignupDisabled && action !== 'force_auth') {
        return this.chooseEmailActionPage();
      } else if (action === 'force_auth') {
        this.replaceCurrentPage(action);
      } else if (action) {
        return this.chooseEmailActionPage();
      } else if (this.getSignedInAccount().get('sessionToken')) {
        this.replaceCurrentPage('settings');
      } else {
        return this.chooseEmailActionPage();
      }
    }
  }, {
    key: "afterVisible",
    value: function afterVisible() {
      _get(_getPrototypeOf(IndexView.prototype), "afterVisible", this).call(this);

      if (this._hasEmailBounced()) {
        this.showValidationError('input[type=email]', AuthErrors.toError('SIGNUP_EMAIL_BOUNCE'));
      } // The CAD via QR and newsletters experiment are mutally exclusive
      // so a user can only be enrolled in one of them at a time. This
      // select the experiment the user will belong to.


      this.getAndReportExperimentGroup('newsletterCadChooser'); // This is so we can show the delete success message after redirect
      // from the settings beta.

      if (this.getSearchParam('delete_account_success')) {
        this.displaySuccess(t('Account deleted successfully'));
      }
    }
  }, {
    key: "chooseEmailActionPage",
    value: function chooseEmailActionPage() {
      const relierEmail = this.relier.get('email');
      const accountFromPreviousScreen = this.getAccount();
      const suggestedAccount = this.suggestedAccount(); // let's the router know to use the email-first signin/signup page

      this.notifier.trigger('email-first-flow');

      if (accountFromPreviousScreen) {// intentionally empty
        // shows the email-first template, the prefill email was set in beforeRender
      } else if (typeof relierEmail === 'string') {
        // the relier email is in the form already since it was used as the prefillEmail
        // in beforeRender. Check whether the email is valid, and if so submit. If the
        // email is not valid then show a validation error to help the user. See #6584
        if (this.isValid()) {
          return this.checkEmail(relierEmail);
        } else {
          // the email was not valid, show any validation errors.
          // The relier email set used as the prefill email in beforeRender.
          this.showValidationErrors();
        }
      } else if (this.allowSuggestedAccount(suggestedAccount)) {
        this.replaceCurrentPage('signin', {
          account: suggestedAccount
        });
      } // else, show the email-first template.

    }
  }, {
    key: "submit",
    value: function submit() {
      return this.checkEmail(this._getEmail());
    }
  }, {
    key: "isValidEnd",
    value: function isValidEnd() {
      if (this._isEmailFirefoxDomain(this._getEmail())) {
        return false;
      }

      if (this._isEmailSameAsBouncedEmail()) {
        return false;
      }

      return _get(_getPrototypeOf(IndexView.prototype), "isValidEnd", this).call(this);
    }
  }, {
    key: "showValidationErrorsEnd",
    value: function showValidationErrorsEnd() {
      if (this._isEmailSameAsBouncedEmail()) {
        this.showValidationError('input[type=email]', AuthErrors.toError('DIFFERENT_EMAIL_REQUIRED'));
      } else if (this._isEmailFirefoxDomain(this._getEmail())) {
        this.showValidationError(EMAIL_SELECTOR, AuthErrors.toError('DIFFERENT_EMAIL_REQUIRED_FIREFOX_DOMAIN'));
      }
    }
  }, {
    key: "_getEmail",
    value: function _getEmail() {
      return this.getElementValue(EMAIL_SELECTOR);
    }
  }, {
    key: "_isEmailFirefoxDomain",
    value: function _isEmailFirefoxDomain(email) {
      // "@firefox" or "@firefox.com" email addresses are not valid
      // at this time, therefore block the attempt.
      // the added 'i' disallows uppercase letters
      const firefoxMail = new RegExp('@firefox(\\.com)?$', 'i');
      return firefoxMail.test(email);
    }
  }, {
    key: "_hasEmailBounced",
    value: function _hasEmailBounced() {
      const account = this.getAccount('account');
      return account && account.get('hasBounced');
    }
  }, {
    key: "_isEmailSameAsBouncedEmail",
    value: function _isEmailSameAsBouncedEmail() {
      if (!this._hasEmailBounced()) {
        return false;
      }

      const bouncedEmail = this.getAccount('account').get('email');
      return bouncedEmail && bouncedEmail === this.getElementValue('input[type=email]');
    } // This way we can stub out the call to checkEmailDomain in tests; there is no
    // way to stub the actual function with sinon since we are using ES Modules.

  }, {
    key: "_validateEmailDomain",
    value: function _validateEmailDomain() {
      const $emailInputEl = this.$(EMAIL_SELECTOR);

      if (this.config.mxRecordValidation) {
        if (this.config.mxRecordValidation.enabled === false) {
          return Promise.resolve(true);
        }

        if ($emailInputEl && this.config.mxRecordValidation.exclusions.length) {
          const _$emailInputEl$val$sp = $emailInputEl.val().split('@'),
                _$emailInputEl$val$sp2 = _slicedToArray(_$emailInputEl$val$sp, 2),
                domain = _$emailInputEl$val$sp2[1];

          if (this.config.mxRecordValidation.exclusions.includes(domain)) {
            return Promise.resolve(true);
          }
        }
      }

      return checkEmailDomain($emailInputEl, this);
    }
    /**
     * Check `email`. If registered, send the user to `signin`,
     * if not registered, `signup`
     *
     * @param {String} email
     * @returns {Promise}
     */

  }, {
    key: "checkEmail",
    value: function checkEmail(email) {
      let account = this.user.initAccount({
        email
      }); // before checking whether the email exists, check
      // that accounts can be merged.

      return this.invokeBrokerMethod('beforeSignIn', account).then(() => this.user.checkAccountEmailExists(account)).then(exists => {
        const nextEndpoint = exists ? 'signin' : 'signup';

        if (exists) {
          // If the account exists, use the stored account
          // so that any stored avatars are displayed on
          // the next page.
          account = this.user.getAccountByEmail(email); // the returned account could be the default,
          // ensure its email is set.

          account.set('email', email);
          this.navigate(nextEndpoint, {
            account
          });
        } else {
          // The email address does not belong to a current user. Validate its
          // domain name.
          return this._validateEmailDomain().then(() => this.navigate(nextEndpoint, {
            account
          })) // checkEmailDomain will display the appropriate error
          // messsage/tooltip; we don't need additional error handling here.
          .catch(e => {});
        }
      });
    }
  }]);

  return IndexView;
}(FormView);

Cocktail.mixin(IndexView, CachedCredentialsMixin, CoppaMixin({}), ExperimentMixin, FlowBeginMixin, FormPrefillMixin, ServiceMixin, ThirdPartyAuthMixin, SignedInNotificationMixin, SyncSuggestionMixin({
  entrypoint: 'fxa:enter_email',
  flowEvent: 'link.signin'
}), PocketMigrationMixin);
export default IndexView;